import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from 'antd';
import { compose } from 'recompose';
import commaNumber from 'comma-number';
import { connectAccount } from 'core';
import coinImg from 'assets/img/strike_32.png';
import { Card } from 'components/Basic/Card';

const CardWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 6px;
  background-color: var(--color-bg-primary);
  padding: 37px 45px;

  img {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 16px;
  }

  p {
    font-size: 17.5px;
    font-weight: 900;
    color: var(--color-text-main);
  }

  .copy-btn {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: var(--color-bg-active);
    margin-left: 26px;

    i {
      color: var(--color-text-main);
      svg {
        transform: rotate(-45deg);
      }
    }
  }
`;

const format = commaNumber.bindWith(',', '.');

function CoinInfo({ address, balance, ensName, ensAvatar }) {
  const handleLink = () => {
    window.open(
      `${process.env.REACT_APP_ETH_EXPLORER}/address/${address}`,
      '_blank'
    );
  };

  return (
    <Card>
      <CardWrapper className="flex align-center just-between">
        <div className="flex align-center">
          <img src={coinImg} alt="coin" />
          <p>{format(balance)}</p>
        </div>
        <div
          className="flex align-center just-center pointer"
          onClick={() => handleLink()}
        >
          {ensAvatar && <img src={ensAvatar} alt="avatar" />}
          <p className="highlight">
            {ensName ||
              `${address.substr(0, 4)}...${address.substr(
                address.length - 4,
                4
              )}`}
          </p>
          <div className="flex align-center just-center copy-btn">
            <Icon type="arrow-right" />
          </div>
        </div>
      </CardWrapper>
    </Card>
  );
}

CoinInfo.propTypes = {
  address: PropTypes.string,
  balance: PropTypes.string,
  ensName: PropTypes.string,
  ensAvatar: PropTypes.node
};

CoinInfo.defaultProps = {
  address: '',
  balance: '0.0000',
  ensName: '',
  ensAvatar: null
};

const mapStateToProps = ({ account }) => ({
  settings: account.setting
});

export default compose(connectAccount(mapStateToProps, undefined))(CoinInfo);
